// extracted by mini-css-extract-plugin
export default {"iframe":"Example_iframe__VW91e","ul":"Example_ul__JMVcW","removeDots":"Example_removeDots__vtMZL"};